import * as React from 'react';
import styled from 'styled-components';
import {DocumentValue} from 'api/lesson/types';
import {getFilePath} from 'api/library';
import Container from 'containers/Container';
import BoxContainer from 'containers/BoxContainer';
import FileContainer from './components/FileContainer';
import ButtonLink from 'components/ButtonLink';
import {ButtonVariant} from 'components/Button';
import getDocumentIcon from 'helpers/get-document-icon';

export interface DocumentTemplateProps {
  value?: DocumentValue;
}

const Wrapper = styled(BoxContainer)`
  padding: 20px;
  align-items: center;
  display: flex;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Icon = styled.div`
  margin-right: 14px;

  @media screen and (max-width: 768px) {
    margin-bottom: 14px;
  }
`;

const Title = styled.span`
  line-height: 20px;
  font-weight: 500;

  @media screen and (max-width: 768px) {
    margin-bottom: 8px;
  }
`;

const Controls = styled.div`
  margin-left: auto;
  gap: 12px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;

  @media screen and (max-width: 768px) {
    margin-left: 0;
    margin-top: 8px;
  }
`;

/**
 * This is the document block of the lesson viewer.
 * @param {DocumentTemplateProps} props
 * @return {React.ReactElement<DocumentTemplateProps> | null}
 * @constructor
 */
export default function DocumentTemplate(
    props: DocumentTemplateProps,
): React.ReactElement<DocumentTemplateProps> | null {
  return props.value ? (
    <FileContainer id={props.value}>
      {(file) => (
        <Container>
          <Wrapper>
            <Icon>
              {getDocumentIcon(file.meta)}
            </Icon>
            <Title>
              {file.title}
            </Title>
            <Controls>
              <ButtonLink
                target="_blank"
                rel="noopener noreferrer"
                href={getFilePath(file.id)}
                variant={ButtonVariant.Outline}
              >
                Посмотреть
              </ButtonLink>
            </Controls>
          </Wrapper>
        </Container>
      )}
    </FileContainer>
  ) : null;
}
